
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.16.2
 * Query Engine version: 4bc8b6e1b66cb932731fb1bdbbc550d1e010de81
 */
Prisma.prismaVersion = {
  client: "4.16.2",
  engine: "4bc8b6e1b66cb932731fb1bdbbc550d1e010de81"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.BillScalarFieldEnum = {
  acceptedAt: 'acceptedAt',
  createdAt: 'createdAt',
  creatorUserId: 'creatorUserId',
  deniedAt: 'deniedAt',
  id: 'id',
  paymentCompletedAt: 'paymentCompletedAt',
  projectId: 'projectId',
  requestedUserId: 'requestedUserId',
  status: 'status',
  termEndAt: 'termEndAt',
  termStartAt: 'termStartAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuestionAnswerScalarFieldEnum = {
  answerContent: 'answerContent',
  answerContentAmpHtml: 'answerContentAmpHtml',
  answerContentHtml: 'answerContentHtml',
  answerContentWordCount: 'answerContentWordCount',
  answerSummaryContent: 'answerSummaryContent',
  answerTableOfContentHtml: 'answerTableOfContentHtml',
  answeredAt: 'answeredAt',
  contributorUserIds: 'contributorUserIds',
  conversionCount: 'conversionCount',
  conversionCountAverageLast30Days: 'conversionCountAverageLast30Days',
  coverImageUrl: 'coverImageUrl',
  createdAt: 'createdAt',
  displayStatus: 'displayStatus',
  fbHelpfulCount: 'fbHelpfulCount',
  fbHelpfulCountLast30Days: 'fbHelpfulCountLast30Days',
  firstAnsweredUserId: 'firstAnsweredUserId',
  googleTopPosition: 'googleTopPosition',
  id: 'id',
  locale: 'locale',
  ogImageUrl: 'ogImageUrl',
  pageViewCount: 'pageViewCount',
  pageViewCountAverageLast30Days: 'pageViewCountAverageLast30Days',
  pageViewCountLast30Days: 'pageViewCountLast30Days',
  privateLastUpdatedUserId: 'privateLastUpdatedUserId',
  privateQaTargetWordId: 'privateQaTargetWordId',
  projectId: 'projectId',
  publishedAt: 'publishedAt',
  questionContent: 'questionContent',
  slug: 'slug',
  subTopicIds: 'subTopicIds',
  talkRoomId: 'talkRoomId',
  topicId: 'topicId',
  updatedAt: 'updatedAt',
  userReactionCount: 'userReactionCount'
};

exports.Prisma.QuestionAnswerContentRevisionScalarFieldEnum = {
  answerContent: 'answerContent',
  answerSummaryContent: 'answerSummaryContent',
  createdAt: 'createdAt',
  id: 'id',
  questionAnswerId: 'questionAnswerId',
  questionContent: 'questionContent',
  status: 'status',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuestionAnswerFeedbackHelpfulScalarFieldEnum = {
  createdAt: 'createdAt',
  firebaseUserId: 'firebaseUserId',
  id: 'id',
  projectId: 'projectId',
  questionAnswerId: 'questionAnswerId',
  topicId: 'topicId'
};

exports.Prisma.QuestionAnswerPageViewScalarFieldEnum = {
  createdAt: 'createdAt',
  firebaseUserId: 'firebaseUserId',
  firstAnsweredUserId: 'firstAnsweredUserId',
  id: 'id',
  projectId: 'projectId',
  questionAnswerId: 'questionAnswerId',
  topicId: 'topicId'
};

exports.Prisma.QuestionAnswerReviewCommentScalarFieldEnum = {
  content: 'content',
  createdAt: 'createdAt',
  id: 'id',
  isResolved: 'isResolved',
  line: 'line',
  questionAnswerId: 'questionAnswerId',
  reviewerUserId: 'reviewerUserId',
  targetQaField: 'targetQaField',
  targetText: 'targetText',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuestionAnswerSearchAnalyticsScalarFieldEnum = {
  clickCount: 'clickCount',
  clickThroughRate: 'clickThroughRate',
  createdAt: 'createdAt',
  displayPosition: 'displayPosition',
  id: 'id',
  impressionCount: 'impressionCount',
  keyword: 'keyword',
  pageUrl: 'pageUrl',
  period: 'period',
  questionAnswerId: 'questionAnswerId',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuestionAnswerUrlClickScalarFieldEnum = {
  createdAt: 'createdAt',
  firebaseUserId: 'firebaseUserId',
  id: 'id',
  projectId: 'projectId',
  questionAnswerId: 'questionAnswerId',
  topicId: 'topicId',
  url: 'url',
  urlDomain: 'urlDomain',
  userAgent: 'userAgent'
};

exports.Prisma.QuestionAnswerUserReactionMapScalarFieldEnum = {
  createdAt: 'createdAt',
  id: 'id',
  questionAnswerId: 'questionAnswerId',
  sectionId: 'sectionId',
  smile: 'smile',
  thumbsUp: 'thumbsUp',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuestionAnswerArticleEvaluationScalarFieldEnum = {
  comment: 'comment',
  createdAt: 'createdAt',
  id: 'id',
  line: 'line',
  questionAnswerId: 'questionAnswerId',
  reviewerUserId: 'reviewerUserId',
  targetQaField: 'targetQaField',
  targetText: 'targetText',
  type: 'type',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserSupportAdUrlClickScalarFieldEnum = {
  createdAt: 'createdAt',
  creatorUserId: 'creatorUserId',
  firebaseUserId: 'firebaseUserId',
  id: 'id',
  projectId: 'projectId',
  questionAnswerId: 'questionAnswerId',
  supportAdId: 'supportAdId',
  url: 'url'
};

exports.Prisma.QaTargetWordScalarFieldEnum = {
  canIncrease: 'canIncrease',
  createdAt: 'createdAt',
  id: 'id',
  isWritable: 'isWritable',
  projectId: 'projectId',
  searchVolume: 'searchVolume',
  searchVolumeUpdatedAt: 'searchVolumeUpdatedAt',
  topicId: 'topicId',
  updatedAt: 'updatedAt',
  word: 'word'
};

exports.Prisma.DictionaryItemScalarFieldEnum = {
  checkExecutionAt: 'checkExecutionAt',
  clickCount: 'clickCount',
  createdAt: 'createdAt',
  id: 'id',
  name: 'name',
  originalImageUrl: 'originalImageUrl',
  parentId: 'parentId',
  projectId: 'projectId',
  regexp: 'regexp',
  slug: 'slug',
  topicId: 'topicId',
  updatedAt: 'updatedAt'
};

exports.Prisma.DictionaryItem_QuestionAnswerScalarFieldEnum = {
  dictionaryItemId: 'dictionaryItemId',
  questionAnswerId: 'questionAnswerId'
};

exports.Prisma.DictionaryItemQaCountScalarFieldEnum = {
  createdAt: 'createdAt',
  dictionaryItemId: 'dictionaryItemId',
  id: 'id',
  locale: 'locale',
  qaCount: 'qaCount',
  updatedAt: 'updatedAt'
};

exports.Prisma.DictionaryItemImageScalarFieldEnum = {
  createdAt: 'createdAt',
  dictionaryItemId: 'dictionaryItemId',
  height: 'height',
  id: 'id',
  updatedAt: 'updatedAt',
  url: 'url',
  width: 'width'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.BillStatus = {
  accepted: 'accepted',
  completed: 'completed',
  created: 'created',
  denied: 'denied'
};

exports.DisplayStatus = {
  created: 'created',
  draft: 'draft',
  publish: 'publish',
  questioned: 'questioned'
};

exports.RevisionStatus = {
  editing: 'editing',
  editingBackUp: 'editingBackUp',
  fixed: 'fixed'
};

exports.TargetQaFieldForReviewComment = {
  answerContent: 'answerContent',
  answerSummaryContent: 'answerSummaryContent',
  coverImage: 'coverImage',
  overview: 'overview',
  questionContent: 'questionContent',
  subtopic: 'subtopic'
};

exports.SearchAnalyticsPeriod = {
  last4weeks: 'last4weeks'
};

exports.QuestionAnswerArticleEvaluationType = {
  convincing: 'convincing',
  informative: 'informative',
  easyToUnderstand: 'easyToUnderstand',
  hardToUnderstand: 'hardToUnderstand'
};

exports.Prisma.ModelName = {
  Bill: 'Bill',
  QuestionAnswer: 'QuestionAnswer',
  QuestionAnswerContentRevision: 'QuestionAnswerContentRevision',
  QuestionAnswerFeedbackHelpful: 'QuestionAnswerFeedbackHelpful',
  QuestionAnswerPageView: 'QuestionAnswerPageView',
  QuestionAnswerReviewComment: 'QuestionAnswerReviewComment',
  QuestionAnswerSearchAnalytics: 'QuestionAnswerSearchAnalytics',
  QuestionAnswerUrlClick: 'QuestionAnswerUrlClick',
  QuestionAnswerUserReactionMap: 'QuestionAnswerUserReactionMap',
  QuestionAnswerArticleEvaluation: 'QuestionAnswerArticleEvaluation',
  UserSupportAdUrlClick: 'UserSupportAdUrlClick',
  QaTargetWord: 'QaTargetWord',
  DictionaryItem: 'DictionaryItem',
  DictionaryItem_QuestionAnswer: 'DictionaryItem_QuestionAnswer',
  DictionaryItemQaCount: 'DictionaryItemQaCount',
  DictionaryItemImage: 'DictionaryItemImage'
};

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
